import Line from '../images/Banner/line.svg';
import Arrow from '../images/Banner/arrow.svg';
import BtnArrow from '../images/btn-arrow.svg';
import Innovly from '../images/Banner/innovly.svg';
import Effortly from '../images/Banner/effortly.svg';
import Dlp from '../images/Banner/dlp.svg';
import Email from '../images/Banner/emaildefence.svg';
import EmailMobile from '../images/Banner/emaildefencemobile.svg'
import './Banner.css';

function Banner() {
    return(
        <section id="home">
            <section className="innovly-ts-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="title-wrap">
                                <h1 className="title">Creating the future through Innovation</h1>
                                <img src={Line} alt="Line" className="line"/>
                                <img src={Arrow} alt="Arrow" className="arrow"/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="info-wrap">
                                <h5 className="info">At SecureForMe, we revolutionize the future with cutting-edge, affordable solutions. Our innovative approach pushes the limits of technology and creativity. Partner with us to transform tomorrow, today!</h5>
                                <a href="/#contact" type="button" className="innovly-btn-primary">Book Demo <img src={BtnArrow} alt="Arrow"/></a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="innovly-banner-wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12"> 
                            <div className="innovly-banner">
                                <img src={Innovly} alt="Innovly" className="banner-logo"/>
                                <div className="banner-responsive banner-info-wrap effort-wrap">
                                    <div>
                                        <h6 className="title">Effortly</h6>
                                        <p className="info">Boost productivity with live insights, time tracking, and custom policies using our intuitive Employee Productivity Monitoring Software.</p>
                                    </div>
                                    <img src={Effortly} alt="Effortly" className="effort-img"/>
                                </div>
                                <div className="banner-responsive banner-info-wrap dlp-wrap">                                
                                    <img src={Dlp} alt="DLP" className="dlp-img"/>
                                    <div>
                                        <h6 className="title">DLP Defence</h6>
                                        <p className="info">Safeguard sensitive data across devices and applications with our Data Loss Prevention Software's advanced encryption and classification features.</p>
                                    </div>
                                </div>
                                <div className="banner-responsive banner-email-defence-wrap">                                
                                    <img src={Email} alt="DLP" className="dlp-img"/>
                                    <div className="banner-email-defence">
                                        <h6 className="title">Email Defence</h6>
                                        <p className="info">Ensure email safety: prevent phishing, spam, ransomware, and data loss, while providing encryption and user training for enhanced security.</p>
                                    </div>
                                    <img src={EmailMobile} alt="DLP" class="dlp-img mobile"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    );
}
export default Banner;